import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import clsx from "clsx";
import { Dispatch, bindActionCreators } from "redux";

import { Overlay, BannerStatus, DefaultActionSection } from "@plex/react-components";

import { INotification } from "infrastructure/notification";
import { Banner } from "ui/app";
import { useUserContext } from "ui/hooks";

import commonStyles from "../shared/styles/Translations.module.scss";

import { TranslationMessagesManagerActionBar } from "./actionBar";
import { TranslationMessagesManagerFilter } from "./filter";
import { TranslationMessagesManagerGrid } from "./grid";
import { translationMessagesActions } from "./TranslationMessages.actions";
import styles from "./TranslationMessages.module.scss";
import { ITranslationMessagesManagerState } from "./TranslationMessages.state";

interface ITranslationMessagesManagerProps {
  state: ITranslationMessagesManagerState;
  initialize: () => void;
  saveTranslations: () => void;
}

const TranslationMessagesManager: React.FC<ITranslationMessagesManagerProps & RouteComponentProps> = ({ state, initialize, saveTranslations }) => {
  useEffect(() => {
    initialize();
  }, [initialize]);

  const userContext = useUserContext();
  const roles = userContext.getRoleAccessData();

  const saveTranslationsExecute = useCallback(() => {
    saveTranslations();
  }, [saveTranslations]);

  const bannerScroll = useCallback((message: INotification) => {
    return message.type === BannerStatus.error;
  }, []);

  return (
    <div className={clsx(styles.base, commonStyles.withActionSection)}>
      <Overlay show={state.isLoading} showSpinner />
      <Banner shouldScroll={bannerScroll} messages={state.notifications} />
      <TranslationMessagesManagerFilter />
      <TranslationMessagesManagerActionBar />
      <TranslationMessagesManagerGrid />
      {(roles.LocalizationManager || roles.PlexLocalizationManager) && <DefaultActionSection onApply={saveTranslationsExecute} />}
    </div>
  );
};

export default connect(
  (state: { translationMessagesManager: ITranslationMessagesManagerState }) => {
    return {
      state: state.translationMessagesManager
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators(
      {
        saveTranslations: translationMessagesActions.saveTranslations,
        initialize: translationMessagesActions.initialize
      },
      dispatch
    );
  }
)(TranslationMessagesManager);
